import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// Instagram ikonunu buraya ekledim
import { Phone, Mail, MapPin, Clock, CalendarCheck, ShieldCheck, Heart, Star, Instagram } from 'lucide-react';
import Navbar from '../Navbar/Navbar';
import FooterSection from '../FooterSection/FooterSection';
import QuickAccess from '../QuickAccess/QuickAccess';
import './ContactPage.css';
import DoctorName from '../DoctorName/DoctorName';

const ContactPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-page">
      <Navbar />

      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>
        <div className="container">
          <div className="contact-hero-content">
            <span className="contact-badge">İLETİŞİM</span>
            <h1>Minik Kahramanlar İçin <span>Buradayız</span></h1>
            <p>
              <DoctorName/> Kliniği'ne ulaşmak ve randevu oluşturmak için 
              aşağıdaki kanalları kullanabilirsiniz.
            </p>
          </div>
        </div>
        <div className="hero-wave-container">
          <svg viewBox="0 0 1440 320" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#fcfdfe" d="M0,192L80,213.3C160,235,320,277,480,261.3C640,245,800,171,960,165.3C1120,160,1280,224,1360,256L1440,288L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
          </svg>
        </div>
      </section>

      <section className="contact-main-section">
        <div className="container">
          <div className="contact-grid">
            {/* İletişim Bilgileri Side */}
            <div className="contact-info-side">
              <div className="info-card-playful">
                <div className="info-item">
                  <div className="info-icon-box" style={{ '--bg': '#e0f2f1', '--color': '#2AB2AF' }}>
                    <MapPin />
                  </div>
                  <div className="info-text">
                    <h4>Kliniğimizin Adresi</h4>
                    <p>Mehmet Akif Ersoy Mah. 49-4. Sk. Hisar Ofis No: 5 Kat: 1 Daire: 102 Merkez/Sivas</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon-box" style={{ '--bg': '#fff3e0', '--color': '#FFB347' }}>
                    <Phone />
                  </div>
                  <div className="info-text">
                    <h4>Telefon Numaralarımız</h4>
                    <a href="tel:+905076444022" className="contact-tel">0 (507) 644 40 22</a>
                    <a href="tel:+905423666626" className="contact-tel">0 (542) 366 66 26</a>
                  </div>
                </div>

                {/* YENİ: İnstagram Bilgi Satırı */}
                <div className="info-item">
                  <div className="info-icon-box" style={{ '--bg': '#fce4ec', '--color': '#e91e63' }}>
                    <Instagram />
                  </div>
                  <div className="info-text">
                    <h4>Sosyal Medya</h4>
                    <a href="https://www.instagram.com/mahmut.aluc/" target="_blank" rel="noopener noreferrer" className="contact-tel">@mahmut.aluc</a>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon-box" style={{ '--bg': '#f1f8e9', '--color': '#7ED957' }}>
                    <Clock />
                  </div>
                  <div className="info-text">
                    <h4>Çalışma Saatleri</h4>
                    <p>Hafta İçi: 08:30 - 17:30</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Randevu Alanı Side */}
            <div className="contact-appointment-side">
              <div className="appointment-card-modern">
                <div className="appointment-features">
                  <div className="feat-item"><ShieldCheck color="#2AB2AF" /> <span>30+ Yıllık Klinik Deneyim</span></div>
                  <div className="feat-item"><Heart color="#FFB347" /> <span>Şefkatli ve Modern Yaklaşım</span></div>
                </div>
                <h3>Online Randevu</h3>
                <button className="big-appointment-btn" onClick={() => navigate('/randevu-al')}>
                  <CalendarCheck size={24} />
                  <span>HEMEN RANDEVU AL</span>
                </button>
                
                {/* YENİ: İnstagram Hızlı Erişim Butonu */}
                <a href="https://www.instagram.com/mahmut.aluc/" target="_blank" rel="noopener noreferrer" className="insta-follow-btn">
                  <Instagram size={20} />
                  <span>Bizi Instagram'da Takip Edin</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

    <section className="contact-map-section">
  <div className="map-container">
    <iframe 
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.921600357244!2d37.030093099999995!3d39.7414119!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4079552ba185eb49%3A0xc6beb8f64d962d7c!2sOp.%20Dr.%20Mahmut%20Alu%C3%A7!5e0!3m2!1str!2str!4v1778618255581!5m2!1str!2str" 
      width="100%" 
      height="450" 
      style={{ border: 0, borderRadius: '30px' }} 
      allowFullScreen="" 
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Dr. Mahmut Aluç Klinik Konum"
    ></iframe>
  </div>
</section>

      <FooterSection />
      <QuickAccess />
    </div>
  );
};

export default ContactPage;